/**
 * DRF returns the next page as an absolute URL; `useInfiniteQuery` wants the
 * page number it carries.
 */
const getNextPageParam = (lastPage: { next?: string | null }): number | undefined => {
  if (!lastPage.next) return undefined;

  const nextPage = new URL(lastPage.next).searchParams.get('page');
  if (!nextPage) return undefined;

  const asNumber = Number(nextPage);
  return Number.isInteger(asNumber) ? asNumber : undefined;
};

export default getNextPageParam;
